// Copyright 2026, University of Maryland, All Rights Reserved
/**
 * Module-level registry of renderer components.
 *
 * Applications register their components at boot via `registerRendererComponent`.
 * The dashboards and the renderer-edit dialog look components up by id.
 */
import type { RendererComponentDefinition, RendererComponentGroup } from './types'

const registry = new Map<string, RendererComponentDefinition>()

export function registerRendererComponent(def: RendererComponentDefinition): void {
  registry.set(def.id, def)
}

export function getRendererComponent(id: string | null | undefined): RendererComponentDefinition | null {
  if (!id) return null
  return registry.get(id) ?? null
}

export function listRendererComponentsByGroup(): Array<{
  group: RendererComponentGroup
  components: RendererComponentDefinition[]
}> {
  const groups = new Map<RendererComponentGroup, RendererComponentDefinition[]>()
  for (const def of registry.values()) {
    const list = groups.get(def.group) ?? []
    list.push(def)
    groups.set(def.group, list)
  }
  return Array.from(groups.entries()).map(([group, components]) => ({ group, components }))
}
